import { ReactElement } from 'react';

interface XCircleProps {
  size?: number;
  color?: string;
}

export const XCircle = ({ color, size }: XCircleProps): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? '64'}
    height={size ?? '65'}
    fill="none"
    viewBox="0 0 64 65"
  >
    <path
      stroke={color ?? '#DD1818'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m39.999 24.5-16 16m0-16 16 16m18.666-8c0 14.727-11.939 26.666-26.666 26.666S5.332 47.227 5.332 32.5 17.272 5.833 31.999 5.833 58.665 17.773 58.665 32.5"
    />
  </svg>
);
